import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";
import { mediaUrl } from "@/lib/api";

const BrandingContext = createContext({ logo_url: null, favicon_url: null, alt_text: "" });
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const BrandingProvider = ({ children }) => {
  const [branding, setBranding] = useState({});

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${BACKEND_URL}/api/site/branding`)
      .then((r) => { if (!cancelled) setBranding(r.data || {}); })
      .catch(() => { if (!cancelled) setBranding({}); });
    return () => { cancelled = true; };
  }, []);

  // Update the browser favicon whenever branding changes.
  useEffect(() => {
    if (!branding.favicon_url) return;
    const link = document.getElementById("site-favicon") || document.createElement("link");
    link.id = "site-favicon";
    link.rel = "icon";
    link.type = branding.file_type || "image/png";
    link.href = mediaUrl(branding.favicon_url);
    if (!link.parentNode) document.head.appendChild(link);
  }, [branding.favicon_url, branding.file_type]);

  const value = useMemo(
    () => ({
      logo_url: branding.logo_url || null,
      favicon_url: branding.favicon_url || null,
      alt_text: branding.alt_text || "Glories of India Publications",
    }),
    [branding.logo_url, branding.favicon_url, branding.alt_text],
  );

  return <BrandingContext.Provider value={value}>{children}</BrandingContext.Provider>;
};

export const useBranding = () => useContext(BrandingContext);
